export const REF_LINKS = {
  V_EDITOR_HEADER_BUTTON: 'v-editor-header-button',
  V_EDITOR_HEADER_DISCOUNT_BUTTON: 'v-editor-header-discount-button',
  V_EDITOR_AI_IMAGE_GENERATE: 'v-editor-ai-image-generate',
  V_EDITOR_AI_VIDEO_GENERATE: 'v-editor-ai-video-generate',
  V_EDITOR_AI_IMAGE_REFILL: 'v-editor-ai-image-refill',
  V_EDITOR_AI_VIDEO_REFILL: 'v-editor-ai-video-refill',
  V_EDITOR_TTS_GENERATE: 'v-editor-tts-generate',
  V_EDITOR_AI_AVATAR_REFILL: 'v-editor-ai-avatar-refill',
  V_EDITOR_AVATAR_UPGRADE_FOR_LONGER_VIDEOS:
    'v-editor-avatar-upgrade-for-longer-videos',
  V_EDITOR_AVATAR_UPGRADE_FOR_HIGHER_QUALITY:
    'v-editor-avatar-upgrade-for-higher-quality',
  V_EDITOR_AVATAR_GENERATE: 'v-editor-avatar-generate',
  PREMIUM_AI_MODELS: 'premium-ai-models-v-editor',
  LOW_PRIORITY_LIMIT: 'low-priority-limit'
}
